"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageService = void 0;
const imagemodel_1 = require("../model/imagemodel");
class ImageService {
    constructor($q, $http, $rootScope, uploadService, assetFormats, toolbox) {
        this.$q = $q;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.uploadService = uploadService;
        this.assetFormats = assetFormats;
        this.toolbox = toolbox;
        this.extentionAssetFormatMap = {
            'jpg': 'jpg',
            'jpeg': 'jpg',
            'gif': 'gif',
            'eps': 'eps',
            'svg': 'svg',
            'tif': 'tiff',
            'tiff': 'tiff'
        };
        this.baseUrl = 'Api/Images/';
    }
    getImage(imageId) {
        const uri = `${this.baseUrl}${imageId}`;
        return this.$http.get(uri).then(response => new imagemodel_1.ImageModel(response.data));
    }
    getAssetFormats(imageId) {
        const uri = `${this.baseUrl}${imageId}/AssetFormats`;
        return this.$http.get(uri).then((response) => response.data);
    }
    upload(imageId, file) {
        const uri = `${this.baseUrl}${imageId}`;
        return this.uploadService.upload(uri, 'PUT', file).then(response => response === null || response === void 0 ? void 0 : response.data);
    }
    getImageUrl(imageId, assetFormat) {
        const uri = `${this.baseUrl}${imageId}/${assetFormat}`;
        // Add images: images can't be cached at the moment
        return this.toolbox.addCacheBuster(uri.toString());
    }
    getImagePreviewUrl(imageId) {
        const uri = `${this.baseUrl}preview/${imageId}`;
        // Add images: images can't be cached at the moment
        return this.toolbox.addCacheBuster(uri.toString());
    }
    getAssetFormatFromFilename(filename) {
        var extension = filename.split('.').pop().toLowerCase();
        return this.extentionAssetFormatMap[extension];
    }
}
exports.ImageService = ImageService;
ImageService.$inject = ['$q', '$http', '$rootScope', 'uploadService', 'assetFormats', 'toolbox'];
